import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const TermsAndConditions = () => {
  const pathName = useLocation().pathname;
  return (
    <Container maxWidth="md">
      <Box py={4}>
        <Typography variant="h4" gutterBottom>
          Terms and Conditions
        </Typography>

        <Typography variant="body1" paragraph>
          Welcome to Blue Bike. By accessing or using our platform, you agree to
          be bound by these Terms and Conditions. If you do not agree with any
          part of these terms, please do not use our services.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Eligibility
        </Typography>
        <Typography variant="body1" paragraph>
          You must be at least 18 years old to use the Blue Bike platform. By
          using our services, you represent and warrant that you meet this
          requirement.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. User Responsibilities
        </Typography>
        <Typography variant="body1" paragraph>
          Users are responsible for providing accurate information when
          registering, listing a bike, or making inquiries. Blue Bike is not
          responsible for any issues arising from incorrect or misleading
          information.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Listing and Transactions
        </Typography>
        <Typography variant="body1" paragraph>
          All bike listings must include truthful and complete information. Blue
          Bike is a facilitator and does not take part in actual transactions
          between buyers and sellers. We do not guarantee the quality, safety,
          or legality of listed bikes.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Communication
        </Typography>
        <Typography variant="body1" paragraph>
          Communication between buyers and sellers on Blue Bike must remain
          professional and respectful. Any misuse of the platform may result in
          account suspension or removal.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Intellectual Property
        </Typography>
        <Typography variant="body1" paragraph>
          All content on Blue Bike, including text, logos, and images, is the
          property of Blue Bike or its licensors. You may not use or reproduce
          any content without prior written permission.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Privacy
        </Typography>
        <Typography variant="body1" paragraph>
          Please refer to our{" "}
          <Link
            to="/privacy"
            className={`hover:text-yellow-300 ${
              pathName === "/privacy" && "font-semibold"
            }`}
          >
            Privacy&nbsp;
          </Link>
          to understand how we collect, use, and protect your information.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Termination
        </Typography>
        <Typography variant="body1" paragraph>
          Blue Bike reserves the right to terminate or suspend your account at
          any time, with or without notice, for violating these terms or for any
          other reason we deem necessary.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          Blue Bike is not liable for any direct, indirect, incidental, or
          consequential damages resulting from your use of the platform,
          including but not limited to loss of data, profits, or reputation.
        </Typography>

        <Typography variant="h6" gutterBottom>
          9. Changes to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          We may update these Terms and Conditions from time to time. Continued
          use of the platform after changes are posted constitutes your
          acceptance of the new terms.
        </Typography>

        <Typography variant="h6" gutterBottom>
          10. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms and Conditions, please
          contact us at{" "}
          <Link href="mailto:support@bluebike.in">support@bluebike.in</Link>.
        </Typography>

        <Typography
          variant="caption"
          display="block"
          color="text.secondary"
          mt={2}
        >
          Last updated: April 19, 2025
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndConditions;
